import { useTranslation } from 'react-i18next';
import { ArrowRightOutlined } from '@ant-design/icons';
import EmptyBox from 'components/atoms/icons/empty-box';

import s from './PageStates.module.scss';

import type { FC } from 'react';
import type { TabKey } from 'pages/TasksDashboard/types';

interface IEmptyStateProps {
  activeTab: TabKey;
  onGoToOpenPool?: () => void;
}

const EmptyState: FC<IEmptyStateProps> = ({ activeTab, onGoToOpenPool }) => {
  const { t } = useTranslation();

  return (
    <div className={s['empty-state-container']} data-cy="empty-state">
      <EmptyBox />
      <p className={s['empty-state-heading']}>
        {t(`tasksDashboard.emptyState.${activeTab}.title`)}
      </p>
      <p className={s['empty-state-body']}>
        {t(`tasksDashboard.emptyState.${activeTab}.description`)}
      </p>
      {activeTab === 'assigned_to_me' && onGoToOpenPool && (
        <button
          type="button"
          className={s['empty-state-link']}
          onClick={onGoToOpenPool}
          data-cy="go-to-open-pool"
        >
          {t('tasksDashboard.emptyState.assigned_to_me.goToOpenPool')}
          <ArrowRightOutlined />
        </button>
      )}
    </div>
  );
};

export default EmptyState;
